import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c(VContainer,{attrs:{"mx-6":""}},[_c(VRow,{attrs:{"flex":""}},_vm._l((_vm.systems.systemTypes),function(systemType){return _c(VCol,{key:systemType.type,staticClass:"flexes"},[_c('SystemTypeCard',{attrs:{"systemType":systemType}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }